import type { SVGProps } from 'react';

const SvgPlusMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M12 4V20M20 12H4' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
  </svg>
);
export default SvgPlusMd;
